import { api } from '../api';
import {
  transformGetArticleByIdResponse,
  transformGetArticlesResponse,
  transformGetCardDefinitionByModuleIdResponse,
  transformGetScenarioByIdResponse,
  transformGetVideosResponse,
} from './activities.transormResponse';

export const activityApi = api.injectEndpoints({
  endpoints: (build) => ({
    getArticleById: build.query({
      providesTags: (response, error, { id }) => [{ id, type: 'articles' }],
      query: ({ id }) => ({
        url: `article/${id}`,
      }),
      transformResponse: transformGetArticleByIdResponse,
    }),
    getArticles: build.query({
      providesTags: ['articles'],
      query: () => ({
        url: 'article',
      }),
      transformResponse: transformGetArticlesResponse,
    }),
    getCardDefinitionByModuleId: build.query({
      query: ({ moduleId }) => ({
        url: `card-definition/${moduleId}`,
      }),
      transformResponse: transformGetCardDefinitionByModuleIdResponse,
    }),
    getNotifications: build.query({
      query: () => ({
        url: 'notification',
      }),
    }),
    getScenarioById: build.query({
      query: ({ id }) => ({
        url: `scenario/${id}`,
      }),
      transformResponse: transformGetScenarioByIdResponse,
    }),
    getScenarios: build.query({
      providesTags: ['scenarios'],
      query: () => ({
        url: 'scenario',
      }),
    }),
    getVideoById: build.query({
      query: ({ id }) => ({
        url: `theory/${id}`,
      }),
    }),
    getVideos: build.query({
      providesTags: ['videos'],
      query: () => ({
        url: 'theory',
      }),
      transformResponse: transformGetVideosResponse,
    }),
    logVideoView: build.mutation({
      query: ({ id }) => ({
        method: 'POST',
        url: `theory/${id}/add-view`,
      }),
    }),
    markArticleAsRead: build.mutation({
      invalidatesTags: (response, error, { articleId }) => [
        { id: articleId, type: 'articles' },
      ],
      query: ({ articleId }) => ({
        method: 'POST',
        url: `/article/${articleId}/complete`,
      }),
    }),
  }),
  reducerPath: 'activityApi',
});
